import {
  collection,
  addDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db, auth } from './config';

export const submitImageFlag = async (flagData) => {
  const userId = auth.currentUser?.uid;
  if (!userId) {
    return { success: false, error: 'User not authenticated' };
  }

  try {
    await addDoc(collection(db, 'image_flags'), {
      ...flagData,
      submittedBy: userId,
      status: 'pending',
      createdAt: serverTimestamp(),
    });
    return { success: true };
  } catch (error) {
    console.error('Error submitting image flag:', error);
    return { success: false, error: error.message };
  }
};
